var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotRequired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.92 1C15.72 0.42 15.16 0 14.5 0H3.5C2.84 0 2.28 0.42 2.08 1L0 7V15C0 15.55 0.45 16 1 16H2C2.55 16 3 15.55 3 15V14H6.25204C6.08751 13.3608 6 12.6906 6 12C6 9.61061 7.04751 7.46589 8.70835 6H2L3.5 1.5H14.5L15.3724 4.11727C16.0067 4.22693 16.6154 4.41127 17.1891 4.66093L15.92 1Z",
    fill: "#303A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5L10 8.5L11.5 7L14.5 10L17.5 7L19 8.5L16 11.5L19 14.5L17.5 16L14.5 13L11.5 16L10 14.5L13 11.5Z",
    fill: "#303A52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRequired);
export default __webpack_public_path__ + "static/media/NotRequired.37686a165e8a981dc9c0585a8f41a808.svg";
export { ForwardRef as ReactComponent };